import { config } from "@/config";
import { useCart } from "@/features/basket/hooks/use-cart";

export function useCartLimit() {
  const { data: cart } = useCart();

  return (cart?.lineItems?.length ?? 0) >= +config.NEXT_PUBLIC_CART_LIMIT;
}
